import { useTranslation } from "react-i18next";
import { ShieldCheck, MapPin, DollarSign, Recycle } from "lucide-react";

const ICONS = [ShieldCheck, MapPin, DollarSign, Recycle];

export default function About() {
  const { t } = useTranslation();
  const values = t("about.values", { returnObjects: true });
  return (
    <div className="mx-auto max-w-5xl px-6 py-16">
      <div className="text-xs font-semibold uppercase tracking-[0.25em] text-teal-700">Company Profile</div>
      <h1 className="mt-3 text-4xl font-bold tracking-tight text-[#0F2942] sm:text-5xl" style={{ fontFamily: "Outfit, sans-serif" }}>{t("about.title")}</h1>
      <p className="mt-6 max-w-3xl text-lg leading-relaxed text-slate-600">{t("about.intro")}</p>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {values.map((v, i) => {
          const Icon = ICONS[i] || ShieldCheck;
          return (
            <div key={i} className="rounded-xl border border-slate-200 bg-white p-6">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-teal-50">
                <Icon className="h-5 w-5 text-teal-700" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-[#0F2942]" style={{ fontFamily: "Outfit, sans-serif" }}>{v.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{v.d}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
